package fr.frux.feature.harvestdetail

import androidx.compose.foundation.layout.Box
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.MoreVert
import androidx.compose.material3.DropdownMenu
import androidx.compose.runtime.Composable
import fr.frux.core.designsystem.components.BlockUserDialog
import fr.frux.core.designsystem.components.FruxIconButton
import fr.frux.core.designsystem.components.ReportContentMenuItem
import fr.frux.core.designsystem.components.ReportUserSheet
import fr.frux.core.designsystem.components.UserModerationMenuItems
import fr.frux.core.designsystem.components.UserReportReason
import fr.frux.feature.harvestdetail.resources.Res
import fr.frux.feature.harvestdetail.resources.harvestdetail_more_actions
import org.jetbrains.compose.resources.stringResource

// Composables de l'ADR 0029 (#515), extraits de HarvestDetailScreen.kt : ratchet detekt
// LongMethod/CyclomaticComplexMethod sur cette fonction, même patron que
// TreeDetailModerationUi.kt.

/**
 * Menu d'actions de la top bar sur la récolte d'autrui : signaler la description, signaler ou
 * masquer l'organisateur (ADR 0029, #515). Rien quand aucun des deux gestes n'est possible
 * (organisateur sur sa propre récolte).
 */
@Composable
internal fun HarvestDetailActionsMenu(
    canModerateOrganizer: Boolean,
    canReportDescription: Boolean,
    organizerName: String,
    showMenu: Boolean,
    onShowMenuChange: (Boolean) -> Unit,
    onReportDescription: () -> Unit,
    onReportOrganizer: () -> Unit,
    onBlockOrganizer: () -> Unit,
) {
    if (!canModerateOrganizer && !canReportDescription) return

    Box {
        FruxIconButton(
            icon = Icons.Outlined.MoreVert,
            contentDescription = stringResource(Res.string.harvestdetail_more_actions),
            onClick = { onShowMenuChange(true) },
        )
        DropdownMenu(expanded = showMenu, onDismissRequest = { onShowMenuChange(false) }) {
            if (canReportDescription) {
                ReportContentMenuItem(onClick = onReportDescription, onDismissMenu = { onShowMenuChange(false) })
            }
            if (canModerateOrganizer) {
                // Une fiche ouverte par lien direct sur un compte déjà masqué repropose
                // « Masquer » : le PUT est idempotent (204).
                UserModerationMenuItems(
                    username = organizerName,
                    isBlocked = false,
                    onReportUser = onReportOrganizer,
                    onBlock = onBlockOrganizer,
                    onUnblock = {},
                    onDismissMenu = { onShowMenuChange(false) },
                )
            }
        }
    }
}

/**
 * Feuille de signalement et confirmation de masquage de l'organisateur (ADR 0029, #515). Extrait
 * de [HarvestDetailScreen] pour sa complexité cyclomatique (detekt CyclomaticComplexMethod).
 */
@Composable
internal fun HarvestDetailModerationOverlays(
    organizerName: String,
    showReportUserSheet: Boolean,
    showBlockDialog: Boolean,
    onReportUserSheetDismiss: () -> Unit,
    onReportOrganizer: (reason: UserReportReason, details: String?) -> Unit,
    onBlockDialogDismiss: () -> Unit,
    onBlockOrganizerConfirmed: () -> Unit,
) {
    if (showReportUserSheet) {
        ReportUserSheet(
            username = organizerName,
            onSubmit = onReportOrganizer,
            onDismiss = onReportUserSheetDismiss,
        )
    }
    if (showBlockDialog) {
        BlockUserDialog(
            username = organizerName,
            onConfirm = onBlockOrganizerConfirmed,
            onDismiss = onBlockDialogDismiss,
        )
    }
}
